import * as types from "../constants/ActionTypes";

export const setFilterAgentDashboard = (to, value) => ({
  type: types.CHANGE_FILTERS_AGENT_DASHBOARD,
  to,
  value,
});
